module.exports = __webpack_public_path__ + "static/media/header_documentation.7776713a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_documentation.jpg
// module id = 316
// module chunks = 1